module.exports = __webpack_public_path__ + "static/img/logo.44cf30e0.jpg";